import {
    Flex,
    Image,
    List,
    ListIcon,
    ListItem,
    useColorMode,
} from '@chakra-ui/react';
import { CheckmarkCircleIcon } from '../../components/icons';

import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getBookListPagePath } from '../../App';
import Button from '../../components/button';
import Layout from '../../components/layout';
import Text from '../../components/text';
import { useSession } from '../../hooks/useSession';


export interface ISuccessProps {
    redirectOrExit: () => void;
}

export default function Success(props: ISuccessProps) {
    const { redirectOrExit } = props;
    const { params } = useRouteMatch<{ state: string; bookName: string }>();
    const { push } = useHistory();

    const session = useSession();
    const currentState = params.state;
    const { colorMode, toggleColorMode } = useColorMode();

    const checkList = [
        `${session?.user?.name} will be able to access your bets directly from ${params.bookName}`,
        `${session?.user?.name} will be able to provide features like automatic bet syncing, personalized analysis, and smarter recommendations!`,
    ];

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    //auto scroll to top of page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    //update selection context with bettor and bettorAccount info
    const updateContext = async () => {
        const url = `${
            process.env.REACT_APP_API_BASE || ''
        }/v1/context/?cid=${session?.cid!}`;
        fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: `Token ${process.env.REACT_APP_SUPERUSER_API_KEY}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                newAccountRegion: currentState, //TODO: Set the state
            }),
        })
            .then((response) => {
                if (response.status === 200) {
                    //pass
                } else {
                    console.log(
                        `WARN - update context response: ${response.status}`
                    );
                }
            })
            .catch((err) => {
                console.log(
                    `Unable to update context with bettoraccount info - ${err}`
                );
            });
    };

    //get region and update context
    useEffect(() => {
        if (session?.type === 'selection') {
            updateContext();
        }
    }, []);

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
            buttons={
                <>
                    <Button
                        variant="secondary"
                        onClick={() =>
                            push(
                                getBookListPagePath(session?.cid!, currentState)
                            )
                        }
                    >
                        Link Another Book
                    </Button>
                    <Button onClick={redirectOrExit} w="full">
                        Continue
                    </Button>
                </>
            }
            hasBackButton={session?.user?.backButton}
        >
            <Flex
                direction="column"
                align="center"
                gap="18px"
                w="full"
                textAlign="center"
                position="relative"
            >
                {session?.logoUrl && (
                    <Image
                        maxH="80px"
                        maxW="200px"
                        src={session?.logoUrl || ''}
                        alt="Sharp Sports"
                    />
                )}
                <Text maxW="340px">
                    Your account was successfully linked to{' '}
                    {session?.user?.name}.
                </Text>
                <Image
                    src={
                        colorMode == 'light'
                            ? '/images/icons/big-check-icon.svg'
                            : '/images/icons/big-check-skyblue-icon.svg'
                    }
                    alt=""
                />
                <div align-items="center">
                    <List spacing="24px">
                        {checkList.map((item, index) => (
                            <ListItem
                                key={`text-${index}`}
                                display="flex"
                                alignItems="center"
                                gap="12px"
                                color={
                                    colorMode == 'light' ? 'navy' : 'skyblue'
                                }
                            >
                                <ListIcon as={CheckmarkCircleIcon} />
                                <Text
                                    size="sm"
                                    textAlign="left"
                                    color={
                                        colorMode == 'light' ? 'navy' : 'white'
                                    }
                                >
                                    {item}
                                </Text>
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Flex>
        </Layout>
    );
}
